import React from "react";

function Footer() {
  return (
    <div className=" fixed bottom-0 flex justify-between items-center bg-[#605DEC] text-white shadow-md  w-full p-5 ">
      <div className="text-base">Generic socials</div>
      <div className="text-xs break-words">© 2023 EzFlights Org</div>
    </div>
  );
}

export default Footer;
